import React from 'react';
import { TutorialItem } from '@/api/tutorial/response';
import { Button } from '@/ui/Button';
import { useTranslation } from 'react-i18next';
import { TutorialSectionInSelection, TutorialSectionOfficial } from '@workspace/shared-constants';
import { Icon } from '@/ui/Icon';
import { Api } from '@/api';
import { TutorialDetailsModal } from './TutorialDetailsModal';
import { useToggle } from 'react-use';

interface IProps {
	section?: TutorialSectionInSelection | TutorialSectionOfficial;
	selectionId?: number;
	tutorial?: TutorialItem;
}

export const TutorialIcon: React.FC<IProps> = ({ section, selectionId, tutorial: tutorialInfo }) => {
	const { i18n } = useTranslation();

	const [tutorial, setTutorial] = React.useState<TutorialItem|null>(null);
	const [isModalOpen, setIsModalOpen] = useToggle(false);

	if (tutorialInfo) {
		return (
				<>
					<Button variant="tetriary" size="sm" onClick={() => setIsModalOpen(true)} className='px-2'>
						<Icon name="info" size={18}/>
					</Button>
					{isModalOpen && (
						<TutorialDetailsModal 
							tutorial={tutorialInfo} 
							isViewModalOpen={isModalOpen} 
							setViewModalOpen={setIsModalOpen} 
						/>
					)}
				</>
			);
	} 

	if (!section) {
		return <></>;
	}
	
	const fetchData = async (section: TutorialSectionInSelection | TutorialSectionOfficial, selectionId: number | undefined) => {
		try {
			const { data } = await Api.instance.tutorialApi.get(section, selectionId);
			if (data) {
				setTutorial(data);
			}
		} catch (e) {
			const error = e as Error;
			// eslint-disable-next-line no-console
			console.error('Error while fetching reports', { error });
			return null;
		}
	};

	React.useEffect(() => {
		fetchData(section, selectionId);
	}, [i18n.language]);

	if (!tutorial) {
		return <></>
	}

	return (
		<>
			<Button variant="tetriary" size="sm" onClick={() => setIsModalOpen(true)}>
				<Icon name="info"/>
			</Button>
			{isModalOpen && tutorial && (
				<TutorialDetailsModal 
					tutorial={tutorial} 
					isViewModalOpen={isModalOpen} 
					setViewModalOpen={setIsModalOpen} 
				/>
			)}
		</>
	);
};
